import { Auth
 } from "aws-amplify";
export const axiosAuthInterceptor = async config => {
    const jwt =  (await Auth.currentSession()).getIdToken()?.getJwtToken();
    if(jwt){
        config.headers.Authorization  = `Bearer ${jwt}`;
    }
    return config;
};